import React from 'react';
import { Zap } from 'lucide-react';

export const BrandMark = ({ compact = false, light = false }) => (
  <div className="flex items-center gap-2.5" data-testid="hirefast-brand">
    <div className="w-8 h-8 rounded-lg bg-indigo-600 flex items-center justify-center shadow-sm shadow-indigo-600/30">
      <Zap className="h-4 w-4 text-white" strokeWidth={2.4} />
    </div>
    <div className="leading-tight">
      <p className={`font-extrabold tracking-tight ${light ? 'text-white' : 'text-slate-900'} ${compact ? 'text-sm' : 'text-base'}`}
        style={{ fontFamily: 'Manrope, sans-serif' }}>HireFast</p>
      <p className={`text-[10px] font-medium tracking-wide ${light ? 'text-indigo-200' : 'text-indigo-600'}`} data-testid="brand-tagline">
        TekWissen Evolution in AI
      </p>
    </div>
  </div>
);

export default BrandMark;
